<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.filterList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>

    <div class="container">
      <div class="text-box">
        默认销售联系人将作为您开展石化相关业务时的唯一联系人使用，将向石化内部系统进行同步，请谨慎修改。
      </div>
      <div class="button-box">
        <eui-btn type="primary" @click="handleAdd">新增联系人</eui-btn>
      </div>
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template #contactTypeSlot="slot">
          <div v-if="slot.scope.row.contactType === '101'">默认</div>
          <div v-if="slot.scope.row.contactType === '102'">
            非默认
          </div></template
        >
        <template #productTypeContentSlot="slot">
          <div v-if="slot.scope.row.isDefaultSelectProductType == 1">
            全部类别
          </div>
          <div v-else>
            {{
              slot.scope.row.productTypeContent &&
              slot.scope.row.productTypeContent.length > 100
                ? slot.scope.row.productTypeContent.slice(0, 100) + '...'
                : slot.scope.row.productTypeContent
            }}
          </div>
        </template>
        <template #salesAreaContentDescSlot="slot">
          <div v-if="slot.scope.row.isDefaultSelectSalesArea == 1">
            全部区域
          </div>
          <div v-else>
            {{
              slot.scope.row.salesAreaContentDesc &&
              slot.scope.row.salesAreaContentDesc.length > 100
                ? slot.scope.row.salesAreaContentDesc.slice(0, 100) + '...'
                : slot.scope.row.salesAreaContentDesc
            }}
          </div>
        </template>

        <template #optionsSlot="slot">
          <eui-btn type="link" size="12" @click="handleEdit(slot.scope.row)"
            >编辑</eui-btn
          >
          <eui-btn
            v-if="slot.scope.row.contactType === '102'"
            type="link"
            size="12"
            @click="handleDelete(slot.scope.row)"
            >删除</eui-btn
          >
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.pageNum"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <FormDialog ref="addDialog" @getList="getList"></FormDialog>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import FormDialog from './formContactDialog.vue';
import Api from '../../api/maintenanceContact';
import { maintenanceContact } from './const';
import eSearch from '../../components/common/e-search';

export default {
  name: 'MaintenanceContact',
  components: {
    FormDialog,
    eTableList,
    eSearch,
  },
  props: {},
  data() {
    return {
      maintenanceContact,
      query: {
        contactType: null,
        contacts: null,
        email: null,
        mobile: null,
      },
      loading: false,
      filterInfo: maintenanceContact.filterInfo,
      listTypeInfo: maintenanceContact.listTypeInfo,
      tableData: [],
      tableLabel: maintenanceContact.tableLabel,
      tableOption: maintenanceContact.tableOption,
      productTagPage: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      roleData: {},
      dialogTitle: '',
      checkRoleDialogShow: false,
      selectRows: [],
      rowKey: 'roleId',
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    // 搜索
    handleQuery(val) {
      this.query = val;
      this.productTagPage.pageNum = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },
    // 重置
    handleReset() {
      this.query = {
        contactType: null,
        contacts: null,
        email: null,
        mobile: null,
      };
      this.productTagPage.pageNum = 1;
      this.productTagPage.pageSize = 10;
      this.productTagPage.pageTotal = 0;
      this.getList();
    },

    // 新增
    handleAdd() {
      const object = this.$refs.addDialog;
      object.initData('');
      this.roleData = {};
    },
    // 删除
    handleDelete(row) {
      const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      this.$confirm('是否删除此联系人？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const query = {
          contactId: row.itemId,
          companyId,
        };
        Api.deleteContact(query)
          .then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '删除成功',
              });
              this.handleReset();
            }
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败',
            });
          });
      });
    },
    // 关闭新增
    closeAdd() {
      this.addDialogShow = false;
      this.getList();
    },
    // 编辑
    handleEdit(row) {
      console.log(row);
      const object = this.$refs.addDialog;
      object.initData(row.itemId, row.companyName, row.customerCompanyList);
      this.roleData = {};
    },

    // 获得列表
    getList() {
      const params = this.query;
      params.companyId = JSON.parse(localStorage.getItem('USERINFO')).companyId;
      params.pageSize = this.productTagPage.pageSize;
      params.pageNum = this.productTagPage.pageNum;

      Api.pageCompanyContacts(params).then((res) => {
        this.tableData = res.data.records;
        this.productTagPage.pageTotal = res.data.total;
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.productTagPage.pageNum = val;
      this.getList();
    },

    // 更改条数
    handleSizeChange(val) {
      this.productTagPage.pageNum = 1;
      this.productTagPage.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .text-box {
    padding: 11px 10px;
    background: #f4f7ff;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: 24px;
    color: #666;
    margin-top: 10px;
    text-align: center;
  }
  .button-box {
    padding-bottom: 10px;
    margin-top: 10px;
  }
}
</style>
